export default "__VITE_ASSET__Dqzd57Vk__"